import { render, staticRenderFns } from "./RadioBase.vue?vue&type=template&id=3cb7c163&"
import script from "./RadioBase.vue?vue&type=script&lang=js&"
export * from "./RadioBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports